import { updateOrders, updateEmptyState } from "components/supplier_admin/shared/queue_polling";

const STATUS_FINISHED = "finished";

const updateStateAndDom = ({ payload, $container, $summaryTotalEl, state }) => {
  state.lastUpdated = payload.last_updated;
  $container.dataset.assemblyQueueLastUpdated = state.lastUpdated;

  if (!payload.job_counts) return;

  if (payload.job_counts.current) {
    const counts = payload.job_counts.current;
    const isFinished = state.status === STATUS_FINISHED;
    const totalCount = isFinished ? counts.total_finished_count : counts.total_active_count;

    if ($summaryTotalEl) $summaryTotalEl.textContent = totalCount;
  }
};

const applyPayload = ({
  payload,
  state,
  $container,
  $listEl,
  $summaryTotalEl,
  $emptyStateEl,
  $paginationEl
}) => {
  updateStateAndDom({
    payload,
    $container,
    $summaryTotalEl,
    state
  });
  updateOrders($listEl, payload.jobs_html);
  updateEmptyState({
    ordersCount: payload.filtered_jobs_count,
    $emptyStateEl,
    $listEl,
    $paginationEl
  });
};

export default applyPayload;
